import { bbox } from "@turf/turf";
import { useEffect, useRef } from "react";

export function FeatureRenderer(props: {
   feature: any,
   id: string,
   color?: string,
   width?: number,
}) {
   const ref = useRef<HTMLCanvasElement>(null);

   useEffect(() => {
      const container = document.getElementById(props.id)
      if (ref.current && container && props.feature) {
         const ctx = ref.current.getContext("2d");

         ref.current.width = container.clientWidth; // Set canvas width
         ref.current.height = container.clientHeight; // Set canvas height
         if (ctx) {
            ctx.lineWidth = props.width || 2;
            ctx.strokeStyle = props.color || "rgba(0, 0, 255, 0.5)";
            
            ctx.clearRect(0, 0, ref.current.width, ref.current.height);
            let bounds = bbox(props.feature);
            let scale = Math.min(ref.current.width / (bounds[2] - bounds[0]), ref.current.height / (bounds[3] - bounds[1])) * 0.9;
            let offsetX = (ref.current.width - (bounds[2] - bounds[0]) * scale) / 2;
            let offsetY = (ref.current.height - (bounds[3] - bounds[1]) * scale) / 2;   
         
            let transform = (a: [number, number]) => {
               return [
                  (a[0] - bounds[0]) * scale + offsetX,
                  (bounds[3] - a[1]) * scale + offsetY // Invert Y axis
               ] as [number, number];
            };

            
            walkFeature(ctx, props.feature, transform);
         }
      }
   }, [props.feature, props.id]);

   return (
      <canvas
         ref={ref}
      />
   );

}

function walkFeature(ctx: CanvasRenderingContext2D ,feature: {features: any[]} | {geometry: any}, transform) {
   if ("features" in feature) {
      feature.features.forEach((f) => walkFeature(ctx, f, transform));
   } else {
      ctx.beginPath();
      walkCoords(feature.geometry.coordinates, ctx, [], transform);
      ctx.closePath();
      ctx.stroke();
   }
}

function walkCoords(coords: any, ctx: CanvasRenderingContext2D, idx:number[], transform: (a: [number,number]) => [number,number]) {
   if (coords.length === 0) return;
   if (coords[0] instanceof Array) {
      coords.forEach((coord: any, lid) => {
         walkCoords(coord, ctx, [...idx,lid], transform);
      });
   } else {
      let transformed = transform(coords)
      if (idx.at(-1) === 0) {
         ctx.moveTo(transformed[0], transformed[1]);
      } else {
         ctx.lineTo(transformed[0], transformed[1]);
      }
   }
}